import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {connect} from 'react-redux'
import setSearchProvinceAction from '../../redux/actions/searchReferenceActions/actionSearchProvince'
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
  '& .MuiOutlinedInput-notchedOutline': {
    '&:hover': {
      borderColor: "rgb(0,191,255)",
    },
    '&.Mui-focused': {
      borderColor: "rgb(47, 79, 79)",
    },
  },
  '& .Mui-focused': {
    color: 'white',
  },
  width: 300,
  fontSize: 30,
  backgroundColor: 'rgba(19, 174, 236, 0.54)',
  fontWeight: 'bold'
});

class SearchProvinceForm extends React.Component {

  constructor(props) {
    super(props)
    this.state = { province: '', provinces: { data: [{ 'province': '' }] }};
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeForm = this.handleChangeForm.bind(this);
    this.props.setSearchProvinceFunction('');
  }

  // fetch by adding charachters in province-inputform
  async handleChange(event) {
 
    this.setState({ province: event.target.value});
    if (event.target.value.length >= 2) {
      const response = await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/searchRef/province?province=${this.state.province}&language=${localStorage.getItem('language')}`);
      const json = await response.json();
      this.setState({ provinces: json });
    }
  };


  handleChangeForm(event, value) {
    if (value !== null) {
      this.setState({ province: value}, () => {
        this.props.setSearchProvinceFunction(this.state.province);
        // this.setState({ provinces: { data: [{ 'province': '' }] } });
      });
    } else {
      this.setState({ province: '' }, () => {
        this.props.setSearchProvinceFunction(this.state.province);
      });
    }
  };
  
  render() {
    const { classes } = this.props;
    const { t } = this.props;

    return (
      <div>
        <Autocomplete
        classes={classes}
          id="combo-box-province"
          onChange={this.handleChangeForm}
          options={this.state.provinces.data}
          isOptionEqualToValue={(option, value) => option.province === value.province}
          noOptionsText={'Wrong input data'}
          getOptionLabel={(option) => option.province}
         
          renderInput={(params) => <StyledTextField  {...params} style={{ width: 300, fontSize: 30, backgroundColor: 'rgba(19, 174, 236, 0.54)' }} onChange={this.handleChange} label={t("create_ref.province")} variant="outlined" />}
        />
        </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
    return {
    setSearchProvinceFunction: searchProvince => {
        dispatch(setSearchProvinceAction(searchProvince))
    }
}
}

export default connect(null, mapDispatchToProps)(withTranslation()(SearchProvinceForm));